module.exports = __webpack_public_path__ + "static/media/placeholder4.ad307738.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/placeholder4.png
// module id = 626
// module chunks = 0